import CardIcon, { CardFlag } from "@/shared/ui/components/card-icon";
import { NewCardIcon } from "@/shared/ui/icons/new-card";
import { type StoredCard, CardScheme } from "@/types";

export const parseCardDate = (
  date: string,
): { month: number; year: number } => {
  try {
    // Handle both masked format (MM/YY) and raw format (MMYY)
    const cleanDate = date.replace(/\D/g, ""); // Remove all non-digits
    if (cleanDate.length >= 4) {
      const month = parseInt(cleanDate.substring(0, 2));
      const year = parseInt(cleanDate.substring(2, 4));
      return { month, year };
    }

    // Fallback to original logic for backward compatibility
    const splitResult = date.split("/");
    return { month: parseInt(splitResult[0]), year: parseInt(splitResult[1]) };
  } catch {
    return {
      month: 0,
      year: 0,
    };
  }
};

export const getPaymentIcon = (type: string) => {
  if (type === "apple_pay") {
    return <CardIcon type={CardFlag.APPLE_PAY} />;
  }
  if (type === "card") {
    return <CardIcon type={CardFlag.MADA} />;
  }
  if (type === "new") {
    return <NewCardIcon />;
  }
  return <NewCardIcon />;
};

export const resolveScheme = (card: StoredCard): CardScheme =>
  card.schemeLocal === CardScheme.UNKNOWN ? card?.scheme : card.schemeLocal;
